import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export interface AlertMessage {
  type: 'success' | 'error' | 'info' | 'warning'
  title?: string
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject = new BehaviorSubject<AlertMessage | null>(null)
  alert$ = this.alertSubject.asObservable()

  showSuccess(message: string, title?: string) {
    this.showAlert({ type: 'success', message, title })
  }

  showError(message: string, title?: string) {
    this.showAlert({ type: 'error', message, title })
  }

  showWarning(message: string, title?: string) {
    this.showAlert({ type: 'warning', message, title })
  }

  private showAlert(message: AlertMessage, autoDismiss: number = 5000) {
    this.alertSubject.next(message)

    autoDismiss = autoDismiss > 0 ? autoDismiss : 5000
    setTimeout(() => this.clear(), autoDismiss)
  }

  clear(): void {
    this.alertSubject.next(null)
  }
}
